// extracted by mini-css-extract-plugin
module.exports = {"container":"FireflyImage_container__uV_b_","image":"FireflyImage_image__DNIt7"};